// Asks the browser for the current position. Never prompts on its own: call it
// from a user action. Denial, timeout and missing support are logged and
// swallowed, so callers just never get a callback.
export function requestLocation(onLocation) {
  if (!("geolocation" in navigator)) {
    console.warn("Geolocation is not available in this browser");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    ({ coords }) =>
      onLocation({ latitude: coords.latitude, longitude: coords.longitude }),
    (error) => console.warn(`Geolocation unavailable: ${error.message}`),
    { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 },
  );
}
